import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

// Toast configuration for different types
const toastConfig = {
  position: 'bottom-end',
  showConfirmButton: false,
  timer: 5000,
  timerProgressBar: true,
  toast: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
}

// Show error toast
export const showErrorToast = (title, text = null) => {
  return MySwal.fire({
    ...toastConfig,
    icon: 'error',
    title,
    text,
    background: '#f8d7da',
    iconColor: '#dc3545'
  })
}

// Show success toast
export const showSuccessToast = (title, text = null) => {
  return MySwal.fire({
    ...toastConfig,
    icon: 'success',
    title,
    text,
    background: '#d4edda',
    iconColor: '#28a745'
  })
}

// Show warning toast
export const showWarningToast = (title, text = null) => {
  return MySwal.fire({
    ...toastConfig,
    icon: 'warning',
    title,
    text,
    background: '#fff3cd',
    iconColor: '#ffc107'
  })
}

// Show info toast
export const showInfoToast = (title, text = null) => {
  return MySwal.fire({
    ...toastConfig,
    icon: 'info',
    title,
    text,
    background: '#d1ecf1',
    iconColor: '#17a2b8'
  })
}

// Parse API error and show appropriate toast
export const showApiErrorToast = (error) => {
  console.error('API Error:', error)

  let title = 'Error'
  let description = 'An unexpected error occurred'

  if (error.response && error.response.data) {
    const errorData = error.response.data

    // Use the enhanced error format from our backend
    if (errorData.message) {
      title = errorData.message
    }

    if (errorData.description) {
      description = errorData.description
    } else if (errorData.message && errorData.message !== title) {
      description = errorData.message
    }

    // Handle specific status codes
    switch (error.response.status) {
      case 400:
        title = 'Invalid Request'
        break
      case 401:
        title = 'Unauthorized'
        description = 'Your session may have expired. Please log in again.'
        break
      case 403:
        title = 'Access Denied'
        description = 'You do not have permission to perform this action.'
        break
      case 404:
        title = 'Not Found'
        description = 'The requested resource was not found.'
        break
      case 409:
        title = 'Conflict'
        break
      case 500:
        title = 'Server Error'
        break
    }
  } else if (error.request) {
    title = 'Network Error'
    description = 'Unable to connect to the server. Please check your internet connection.'
  } else if (error.message) {
    title = 'Error'
    description = error.message
  }

  return showErrorToast(title, description)
}

export default {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
  showInfoToast,
  showApiErrorToast
}
